import { render } from "./Infos.vue?vue&type=template&id=7895efe9&scoped=true"
import script from "./Infos.vue?vue&type=script&lang=js"
export * from "./Infos.vue?vue&type=script&lang=js"

import "./Infos.vue?vue&type=style&index=0&id=7895efe9&scoped=true&lang=scss"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7895efe9"]])

export default __exports__